import React from 'react';
import { useStore } from '../../../common';
import styles from './LastActivity.module.scss';

const LastActivity = (): JSX.Element => {
	const [{ lastActivity }] = useStore();

	return (
		<section className={styles.LastActivity}>
			<div>Last Active</div>
			<section className={styles.Date}>{lastActivity ? lastActivity : 'No recent activity'}</section>
		</section>
	);
};

export { LastActivity };
